export const AUTOMATION_IDS = {
  BUTTON: 'image-to-background-button',
  TOOLTIP: 'image-to-background-tooltip',
};
